module.exports = __webpack_public_path__ + "img/杭州萧山硕人.41c9095.png";